import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bollinger-bands-calculator',
  component: () => import('../../routes/BollingerBandsCalculator.svelte'),
  card: {
    id: 'bollinger-bands-calculator',
    title: 'Bollinger Bands® Calculator',
    description:
      'Compute Bollinger Bands (SMA ± k·σ), %B, and bandwidth for any price series. Identify squeezes, breakouts, and overbought/oversold zones.',
    icon: 'candlestick_chart',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/bollinger-bands-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Bollinger Bands® Calculator – SMA ± k·σ, %B and Bandwidth',
    description:
      'Free Bollinger Bands calculator. Computes the upper, middle, and lower bands (SMA ± k·σ) for any closing-price series. Includes %B (price position), bandwidth (volatility regime), squeeze detection, and signal classification.',
  },
};

export default meta;
